var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21137_248732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7161 51.0068H52.2897L51.7841 50.5193C53.9508 47.9915 55.0702 44.5429 54.4564 40.8776C53.6077 35.8582 49.4189 31.8498 44.3633 31.2359C36.7258 30.297 30.298 36.7248 31.2369 44.3623C31.8508 49.4179 35.8591 53.6068 40.8786 54.4554C44.5439 55.0693 47.9925 53.9498 50.5202 51.7832L51.0077 52.2887V53.7151L58.6814 61.3887C59.4216 62.129 60.6314 62.129 61.3716 61.3887C62.1119 60.6484 62.1119 59.4387 61.3716 58.6984L53.7161 51.0068ZM42.8827 51.0068C38.3869 51.0068 34.7577 47.3776 34.7577 42.8818C34.7577 38.3859 38.3869 34.7568 42.8827 34.7568C47.3786 34.7568 51.0077 38.3859 51.0077 42.8818C51.0077 47.3776 47.3786 51.0068 42.8827 51.0068Z",
    fill: "#5AB453"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7761 36.5441C57.0358 36.6498 56.3589 36.1307 56.1603 35.4096C54.9806 31.1245 51.2749 28.3837 47.1421 27.3258C46.4175 27.1403 45.9171 26.4485 46.04 25.7107C46.163 24.973 46.8619 24.4697 47.5884 24.6473C52.5597 25.8624 57.4489 29.2696 58.86 35.0231C59.0381 35.7494 58.5165 36.4383 57.7761 36.5441Z",
    fill: "#5AB453"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0818 49.7926C27.8096 49.6204 28.5315 50.0755 28.7836 50.7796C30.3168 55.0616 34.0482 57.6544 38.3963 58.0988C39.1403 58.1749 39.7485 58.7736 39.7485 59.5214C39.7485 60.2693 39.1408 60.8818 38.3957 60.8182C32.9047 60.3498 28.0112 57.0294 26.1342 51.407C25.8973 50.6976 26.354 49.9648 27.0818 49.7926Z",
    fill: "#5AB453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2917 7.70833V29.2917H7.70833V7.70833H29.2917ZM29.2917 4.625H7.70833C6.0125 4.625 4.625 6.0125 4.625 7.70833V29.2917C4.625 30.9875 6.0125 32.375 7.70833 32.375H29.2917C30.9875 32.375 32.375 30.9875 32.375 29.2917V7.70833C32.375 6.0125 30.9875 4.625 29.2917 4.625Z",
    fill: "#5AB453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5837 26.2087H10.792V23.1253H21.5837V26.2087ZM26.2087 20.042H10.792V16.9587H26.2087V20.042ZM26.2087 13.8753H10.792V10.792H26.2087V13.8753Z",
    fill: "#5AB453"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.792,
    y: 16.958,
    width: 15.4167,
    height: 3.08333,
    fill: "#5AB453"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.792,
    y: 23.125,
    width: 10.7917,
    height: 3.08333,
    fill: "#5AB453"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21137_248732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.d494f85c.svg";
export { ForwardRef as ReactComponent };